import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-five',
  templateUrl: './two-five.component.html',
  styleUrls: ['./two-five.component.scss']
})
export class TwoFiveComponent implements OnInit {
 
  constructor() { }

  ngOnInit(): void {
   
  }

}
